import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Switch } from '../ui/switch';
import { Save } from 'lucide-react';

const ContactTab = ({ contactInfo, setContactInfo, saving, onSave }) => {
  return (
    <div className="bg-zinc-900 rounded-lg border border-zinc-800 p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-white">Contact Information</h2>
        <Button onClick={onSave} disabled={saving} className="bg-emerald-600 hover:bg-emerald-700">
          <Save className="w-4 h-4 mr-2" />
          {saving ? 'Saving...' : 'Save Changes'}
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Label className="text-zinc-300">Email</Label>
            <div className="flex items-center gap-2">
              <span className="text-zinc-500 text-xs">{contactInfo.show_email ? 'Visible' : 'Hidden'}</span>
              <Switch
                checked={contactInfo.show_email || false}
                onCheckedChange={(val) => setContactInfo({ ...contactInfo, show_email: val })}
              />
            </div>
          </div>
          <Input
            value={contactInfo.email || ''}
            onChange={(e) => setContactInfo({ ...contactInfo, email: e.target.value })}
            className="bg-zinc-800 border-zinc-700 text-white"
          />
        </div>
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Label className="text-zinc-300">Phone</Label>
            <div className="flex items-center gap-2">
              <span className="text-zinc-500 text-xs">{contactInfo.show_phone ? 'Visible' : 'Hidden'}</span>
              <Switch
                checked={contactInfo.show_phone || false}
                onCheckedChange={(val) => setContactInfo({ ...contactInfo, show_phone: val })}
              />
            </div>
          </div>
          <Input
            value={contactInfo.phone || ''}
            onChange={(e) => setContactInfo({ ...contactInfo, phone: e.target.value })}
            className="bg-zinc-800 border-zinc-700 text-white"
          />
        </div>
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Label className="text-zinc-300">Address</Label>
            <div className="flex items-center gap-2">
              <span className="text-zinc-500 text-xs">{contactInfo.show_address ? 'Visible' : 'Hidden'}</span>
              <Switch
                checked={contactInfo.show_address || false}
                onCheckedChange={(val) => setContactInfo({ ...contactInfo, show_address: val })}
              />
            </div>
          </div>
          <Input
            value={contactInfo.address || ''}
            onChange={(e) => setContactInfo({ ...contactInfo, address: e.target.value })}
            className="bg-zinc-800 border-zinc-700 text-white"
          />
        </div>
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Label className="text-zinc-300">Working Hours</Label>
            <div className="flex items-center gap-2">
              <span className="text-zinc-500 text-xs">{contactInfo.show_working_hours ? 'Visible' : 'Hidden'}</span>
              <Switch
                checked={contactInfo.show_working_hours || false}
                onCheckedChange={(val) => setContactInfo({ ...contactInfo, show_working_hours: val })}
              />
            </div>
          </div>
          <Input
            value={contactInfo.working_hours || ''}
            onChange={(e) => setContactInfo({ ...contactInfo, working_hours: e.target.value })}
            className="bg-zinc-800 border-zinc-700 text-white"
          />
        </div>
      </div>
    </div>
  );
};

export default ContactTab;
